/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

//import {firstName,lastName} from "views/examples/Profile.js";
//const searchResults = React.useContext(SearchContext);

const firebase = require("firebase/app");
require("firebase/firestore");

class UserHeader extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
      firstName: "",
      lastName: "",
    }
  }

  //db = firebase.firestore();
  //uid = localStorage.getItem("uid")

  componentDidMount() {
    let db = firebase.firestore();

    let getUserData = async () => {
      const uid = localStorage.getItem("uid");
      let docRef = db.collection("users").doc(uid);

      await docRef.get()
        .then(doc => {
          this.setState(doc.data());
        });
      
      console.log(this.state);
    }
    
    getUserData();
  }



  render() {
    return (
      <>
        <div
          className="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
          style={{
            minHeight: "600px",
            backgroundImage:
              "url(" + require("assets/img/theme/profile_background.jpeg") + ")",
            backgroundSize: "cover",
            backgroundPosition: "center top"
          }}
        >
          {/* Mask */}
          <span className="mask bg-gradient-default opacity-8" />
          {/* Header container */}
          <Container className="d-flex align-items-center" fluid>
            <Row>
              <Col lg="12" md="10">
                <h1 className="display-2 text-white">{"Hello " + this.state.firstName}</h1>
                <p className="text-white mt-0 mb-5">
                  Welcome to Naval Special Warfare - Technology Assisted Stress Control. Let us know a little about yourself.
                </p>
              </Col>
            </Row>
          </Container>
        </div>
      </>
    );
  }
}

export default UserHeader;
